<template>
    <div class="inputWrapper">
        <div class="inputTitle">{{ title }} <span class="icon-rotate-cw"  v-show="!showList" @click="resetOptions(presetValue)"></span> </div>
        <multiselect
          v-model="chosenOptions"
          :options="optionListFiltered.map(i => i.value)"
          :multiple="multi"
          @select="chooseOptions"
          @remove="removeOption"
          :hideSelected="true"
          :showLabels="false"
          :searchable="searchable"
          :placeholder="placeholder"/>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import vOutsideEvents from 'vue-outside-events';
import { mixin as clickaway } from 'vue-clickaway';

Vue.use(vOutsideEvents);

export default {
    mixins: [clickaway],
    props: {
        index: {
            required: true,
        },
        multi: {
            type: Boolean,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
        },
        title: {
            type: String,
        },
        mutationRef: {
            type: String,
            required: true,
        },
        presetValue: {
            type: String,
        },
        overflowy: {
            type: Boolean,
        },
        block: {
            type: Boolean,
        },
        placeholder: {
            type: String,
            default: 'All Selected',
        },
    },
    components: {
        Multiselect,
    },
    data () {
        return {
            chosen: false,
            chosenOptions: [],
            emptyFilter: true,
            optionList: [],
            preset: '',
            selectOptions: [],
            selectedClass: {},
            showList: false,
        };
    },
    beforeMount () {
        for (const n in this.options) {
            this.optionList.push({
                value: this.options[n],
                clicked: false,
            });
        }
        for (const m in this.optionList) {
            if (this.optionList[m].value === this.preset) {
                this.optionList[m].clicked = true;
            } else {
                this.optionList[m].clicked = false;
            }
        }
    },
    created () {
        this.chosenOptions = this.presetValue;
    },
    methods: {
        resetOptions (option) {
            if (this.multi) {
				this.chosenOptions.splice(0);
				this.selectOptions.splice(0);
                this.emptyFilter = true;
                for (const n in this.optionList) {
                    this.optionList[n].clicked = false;
                }
                this.showList = false;
                this.$store.commit('dropdownSelectionMulti', { name: this.mutationRef, options: this.chosenOptions });
            } else {
                this.chosenOptions = this.presetValue;
                this.$emit('input', { name: this.mutationRef, options: option });
            }
        },
        removeOption (option) {
            const index = this.selectOptions.findIndex(i => i === option);
            index > -1 ? this.selectOptions.splice(index, 1) : '';
            this.$store.commit('dropdownSelectionMulti', { name: this.mutationRef, options: this.selectOptions });
        },
        chooseOptions (option) {
            if (this.multi) {
                this.selectOptions.push(option);
                this.$store.commit('dropdownSelectionMulti', { name: this.mutationRef, options: this.selectOptions });
            } else {
                this.$emit('input', { name: this.mutationRef, options: option });
            }
        },
    },
    computed: {
        optionListFiltered () {
            return this.optionList.filter(el => el.value !== '#N/A INVALID SECURITY');
        },
        overflow () {
            return this.overflowy ? 'overflow-y' : '';
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/all.scss';
.inputWrapper {
    -moz-transition: top 0.3s ease-in-out, opacity 0.01s ease;
    -o-transition: top 0.3s ease-in-out, opacity 0.01s ease;
    -webkit-transition: top 0.3s ease-in-out, opacity 0.01s ease;
    display: block;
    min-height: 60px;
    margin-bottom: 10px;
    opacity: 1;
    transition: top 0.3s ease-in-out, opacity 0.01s ease;
    width: 100%;
    &.hideDropdown {
        opacity: 0;
    }
    &.show{
        height: 100%;
        top: 0 !important;
        width: 100%;
        z-index: 100;
    }
    &.overflow-y {
        overflow-y: auto;
    }
}
.inputTitle {
    color: $darkBlue;
    font-size: 18px;
    font-weight: 700;
    .icon-rotate-cw {
        float: right;
        cursor: pointer;
    }
}
.optionWrapper {
    position: relative;
    .currentOption {
        font-size: 16px;
        cursor: pointer;
        background-color: rgb(0, 163, 196);
        color: white;
        padding: 6px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .optionList {
        display: none;
        padding-left: 0;
        font-size: 16px;
        min-height: 580px;
        width: 100%;
        li {
            padding: 6px;
            vertical-align: bottom;
            cursor: pointer;
            &:before {
                font-family: 'icomoon' !important;
                content: "\e91c";
                padding-right: 10px;
            }
            &:hover {
                background-color: $darkBlue;
                color: white;
                &:before{
                    content: "\e91a";
                }
            }
            &.selected {
                    background-color: #002c5c;
                    color: white;
                    &:before {
                        content: "\e91a"!important;
                    }
                }
            &.multi {
                &:before {
                    content: "\e928";
                }
                &:hover {
                    &:before {
                        content: "\e91b"!important;
                    }
                }
                &.selected{
                    background-color: #002c5c;
                    color: white;
                    &:before{
                        content: "\e91b"!important;
                    }
                }
            }
        }
        position: absolute;
        &.show{
            display: block;
        }
    }
}
@media (max-width: 1536px) {
  .inputTitle{
      font-size: 14px;
  }
  .optionWrapper{
    position: relative;
    .currentOption{
        font-size: 14px;
        padding: 4px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import 'src/assets/scss/all.scss';
    input {
        color: #fff!important;
    }
.multiselect__content-wrapper, .multiselect__element {
    z-index: 99!important;
    position: relative!important;
}
.multiselect {
    color: $darkBlue!important;
}

.multiselect__tag, .multiselect__tag-icon {
    background-color: $darkBlue!important;
}

.multiselect__placeholder, .multiselect__tag-icon:after {
    color: #fff!important;
}
</style>
